import ElementContent from '@/components/sections/builder/elements/body/multicolumn/content';
import ElementSetting from '@/components/sections/builder/elements/body/multicolumn/setting';
import Column from '@/components/sections/builder/elements/body/multicolumn/column';
import { ElementDataType } from '@/components/sections/builder/elements/body/multicolumn/type';
import { Columns3 } from 'lucide-react';

const defaultData: ElementDataType = {
  name: 'Multicolumn',
  heading: 'Multicolumn',
  headingSize: '30',
  imageWidth: 'one_third_width',
  imageRatio: 'adapt',
  numberOfColumns: 3,
  columnAlignment: 'left',
  secondaryBackground: 'background1',
  buttonLabel: 'Button label',
  buttonLink: '',
  topPadding: 0,
  bottomPadding: 0,
  contentAlign: 'center',
};

export const ElementPreviewIcon = Columns3;

const Multicolumn = {
  type: 'multicolumn',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [Column, Column, Column],
  childs: [Column],
};

export default Multicolumn;
